import { IInitialChatData } from '../../service/InitialChatData';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { clientSdk } from '../ClientSDK';
import { httpClient } from '../httpClient';
import { RestartChatParameters } from '../reducers/types';
import { addToQueue, debug, handleConflictStatus } from './utils';

const { clientTopology, queryParams: query } = renderModel.get();

export const sendRestartChat = (parameters?: RestartChatParameters) => {
  return clientSdk.getContext(renderModel.getUserId()).then((context) => {
    const queryParameters = {
      ...query,
      ...parameters,
    };

    return httpClient
      .getInstance()
      .post<IInitialChatData>(
        clientTopology.restartURL,
        {
          query: queryParameters,
          context,
        },
        {
          withCredentials: !window.isTest,
        },
      )
      .then(handleConflictStatus)
      .then(addToQueue)
      .then(debug)
      .catch((error) => {
        logger.log({
          message: 'fail to post restart chat',
          error,
          callParams: {
            query: queryParameters,
          },
        });
      });
  });
};
